import * as React from 'react';

interface Props {
    text: string;
    children?: any;
    type?: 'button' | 'reset' | 'submit';
    addlClassName?: string;
    style?: any;
    disabled?: boolean;
    suppressBottomMargin?: boolean;
    removeBoldFont?: boolean;
    onClick?: (e?: React.SyntheticEvent<HTMLButtonElement>) => void;
}

const Button = (props: Props) => {
    return (
        <button
            className={`btn ${props.removeBoldFont ? '' : 'font-weight-bold'}${
                props.suppressBottomMargin ? '' : ' mb-4'
            } ${props.addlClassName || 'btn-primary'}`}
            type={props.type || 'button'}
            onClick={props.onClick}
            style={props.style}
            disabled={props.disabled}
        >
            {props.text}
            {props.children}
        </button>
    );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/form/Button.tsx